var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildeLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 33,
    viewBox: "0 0 195 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_28183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9617 18.5692V0.42334H42.4841V18.3501C42.4841 25.0804 46.0515 28.8725 52.0233 28.8725C57.9952 28.8725 61.4333 25.395 61.4333 18.5748V0.42334H64.9558V18.3052C64.9558 27.4006 59.7367 32.1253 51.9334 32.1253C44.1302 32.1253 38.9561 27.4006 38.9561 18.5692",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8164 0.42334H80.2939V31.6365H83.8164V0.42334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6416 0.42334H103.164V28.3781H120.731V31.6365H99.6416V0.42334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.382 0.42334H171.938V3.63117H194.382V0.42334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.382 28.4229H171.938V31.6307H194.382V28.4229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.388 14.2881H172.04V17.4959H194.388V14.2881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0807 15.4962C21.5301 14.4288 24.03 12.3333 24.03 8.27157V8.18169C24.03 6.17609 23.3166 4.52442 22.0244 3.18736C20.2436 1.45142 17.429 0.42334 13.8672 0.42334H0.507812V3.58623H13.5526C18.0132 3.58623 20.4627 5.59183 20.4627 8.67045V8.76033C20.4627 12.4176 17.5189 14.3333 13.283 14.3333H0.507812V17.4513H13.9122C19.3503 17.4513 22.2042 19.4119 22.2042 22.7995V22.8894C22.2042 26.3669 19.2604 28.4624 14.5358 28.4624H0.507812V31.6253H14.4459C21.266 31.6253 25.7716 28.4624 25.7716 23.1085V23.0186C25.7716 18.7378 22.7829 16.5973 19.0863 15.485",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.282 0.42334H134.018V3.67611H141.282C149.175 3.67611 154.214 9.11426 154.214 16.0243V16.1142C154.214 23.0242 149.175 28.3781 141.282 28.3781H134.018V31.6309H141.282C151.09 31.6309 157.866 24.8107 157.866 16.0243V15.9344C157.866 7.15361 151.09 0.42334 141.282 0.42334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_28183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193.88,
    height: 31.7019,
    fill: "white",
    transform: "translate(0.507812 0.42334)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildeLabel);
export default __webpack_public_path__ + "static/media/builde_label.b6df3e9274eecc2bfda407c6faf5a086.svg";
export { ForwardRef as ReactComponent };